export const JobTitles: string[] = [
  'CEO',
  'CTO',
  'Founder',
  'Director',
  'Software engineer',
  'Software developer',
  'Business development manager',
]
